var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"footer-button",attrs:{"color":"secondary","data-cy":"buttonCart","block":"","to":{
      name: 'products-CheckoutPage',
    }}},[_c('v-badge',{attrs:{"color":"primary","left":"","transition":"slide-x-transition"},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_vm._v(" "+_vm._s(_vm.totalItems)+" ")]},proxy:true}])},[_c('v-icon',{staticClass:"mr-1",attrs:{"color":"black","size":"26"}},[_vm._v(" "+_vm._s(_vm.mdiCartOutline))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }